import { render, staticRenderFns } from "./MedalProgressRing.vue?vue&type=template&id=509e5d4e&scoped=true"
import script from "./MedalProgressRing.vue?vue&type=script&lang=js"
export * from "./MedalProgressRing.vue?vue&type=script&lang=js"
import style0 from "./MedalProgressRing.vue?vue&type=style&index=0&id=509e5d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e5d4e",
  null
  
)

export default component.exports